import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import { useQuery, UseQueryResult } from 'react-query';
import { Dictionary } from 'lib';
import { getSortedDataWithUrl } from './hook-helpers';

export const useDictionaryList = (
    props: any = undefined
): UseQueryResult<AxiosResponse<Dictionary[], any>, unknown> => {
    const queryProps: any = props?.queryProps;
    const { getToken } = useAuth();

    return useQuery(
        'dictionaries',
        async () => getSortedDataWithUrl('/metadata/dictionary', getToken()),
        queryProps
    );
};
